import React, { useRef, useState, useEffect } from 'react'
import { KnovaText } from '../../BasicUIComponents/KnovaText'

function LayoutHeadDesc(props) {
  const {
    fromImage,
    themeName,
    layoutData,
    layoutId,
    layoutType,
    themeProperties,
    isSideMenu
  } = props
  const [headingData, setHeadingData] = useState({})
  const [descriptionData, setdescriptionData] = useState({})

  useEffect(() => {
    let headingDataCopy = layoutData.filter((e) => e.PluginId === 'SCTitle')
    let descriptionDataCopy = layoutData.filter(
      (e) => e.PluginId === 'SCTextArea'
    )

    setHeadingData(headingDataCopy[0])
    setdescriptionData(descriptionDataCopy[0])
  }, [])

  if (
    headingData &&
    descriptionData &&
    headingData !== null &&
    descriptionData !== null
  ) {
    return (
      <div
        className='layout-title-desc-cont'
        style={{
          justifyContent:
            layoutType === 'bottom-left'
              ? 'end'
              : layoutType === 'center'
              ? 'center'
              : 'start',
          gap: isSideMenu ? 'unset' : layoutId === 2 ? '28px' : '14px',
          padding:
            layoutType === 'top-left' || layoutType === 'bottom-left'
              ? '5%'
              : '0px 5%'
        }}
      >
        <div
          className='title-cont'
          style={{ padding: isSideMenu ? '0px 10px' : '0px' }}
        >
          <KnovaText
            themeName={themeName}
            text={headingData.Value}
            textColor={
              fromImage
                ? themeProperties.themeStyles.subHeadingOnLayColor
                : themeProperties.themeStyles.headingColor
            }
            textFontSize={
              isSideMenu ? 'unset' : layoutId === 2 ? '80px' : '50px'
            }
            textFontFamily={themeProperties.themeFont.displayFont}
            textFontWeight='400'
            textHeight={isSideMenu ? 'unset' : '120%'}
            textAlign={layoutType === 'center' ? 'center' : 'left'}
            letterSpacing={layoutId === 2 ? '-0.94px' : '0.64px'}
          />
        </div>
        <div
          className={layoutType === 'top-left' ? 'desc-cont' : 'desc-cont-half'}
          style={{ padding: isSideMenu ? '0px 10px' : '0px' }}
        >
          <KnovaText
            text={descriptionData.Value}
            textColor={themeProperties.themeStyles.normalTextColor}
            textFontSize={isSideMenu ? '5px' : '24px'}
            textFontFamily={themeProperties.themeFont.bodyFont}
            textFontWeight='400'
            textHeight={isSideMenu ? 'unset' : '40px'}
            textAlign={layoutType === 'center' ? 'center' : 'left'}
            letterSpacing='0.32px'
          />
        </div>
      </div>
    )
  } else {
    return null
  }
}
export default LayoutHeadDesc
